angular.module("acl.visualizer.aclColorPicker", ["acl.visualizer.color"]);
